import { IAuthGateway } from '@/core/interface/auth/gateway';
import { AuthChangePresenterFunc, CurrentUserPresenterFunc } from '@/core/interface/auth/presenter';
import { PresenterFunc } from '../interface';

export class AuthService {
  constructor(
    private readonly authGateway: IAuthGateway,
  ) { }

  public async changePassword(oldPassword: string, newPassword: string, presenter: PresenterFunc<void>) {
    presenter(null, undefined, true);
    try {
      await this.authGateway.changePassword(oldPassword, newPassword);

      presenter(null, undefined, false);
    } catch (error) {
      presenter(error, undefined, false);
    }
  }

  public async getCurrentUser(presenter: CurrentUserPresenterFunc) {
    const user = await this.authGateway.getCurrentUser();

    presenter(user);
  }

  public async reset(email: string, presenter: PresenterFunc<undefined>) {
    presenter(null, undefined, true);
    try {
      await this.authGateway.reset(email);

      presenter(null, undefined, false);
    } catch (error) {
      presenter(error, undefined, false);
    }
  }

  public async signIn(email: string, password: string, presenter: AuthChangePresenterFunc) {
    try {
      const user = await this.authGateway.signIn(email, password);

      presenter(null, user, { name: 'home' });
    } catch (error) {
      presenter(error, null, null);
    }
  }

  public async signOut(presenter: AuthChangePresenterFunc) {
    try {
      await this.authGateway.signOut();

      presenter(null, null, { name: 'login' });
    } catch (error) {
      presenter(error, null, null);
    }
  }
}
